import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { canEditData } from '@repo/shared/common';
import { ensureRouteData } from '~/lib/query';
import { currentOrganizationQueryOptions } from '~/lib/queries/organization';
import { uploadDetailQueryOptions } from '~/features/upload/use-uploads';
import { UploadDetailPage } from '~/features/upload/UploadDetailPage';

export const Route = createFileRoute('/_protected/uploads/$uploadId')({
  // Viewer guard: reopening an upload is part of the edit-only uploader surface.
  // Bounce viewers to /unauthorized before the detail loader runs.
  beforeLoad: async ({ context }) => {
    const { role } = await context.queryClient.ensureQueryData(
      currentOrganizationQueryOptions(),
    );
    if (role === null || !canEditData(role)) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  // Reopening a file is page-defining, so await the detail on the server (no
  // flash); a client navigation prefetches it (intent-preloaded on hover).
  loader: ({ context, params }) =>
    ensureRouteData(context.queryClient, uploadDetailQueryOptions(params.uploadId)),
  component: UploadDetailRoute,
});

function UploadDetailRoute(): ReactNode {
  const { uploadId } = Route.useParams();
  return <UploadDetailPage uploadId={uploadId} />;
}
